import React, { Component } from 'react'

import { chainesLocales } from './../include/chainesLocales';

class NousJoindreModal extends Component {
    get labels() {
        return chainesLocales['NousJoindreModal'][this.props.lngChild];
    }

    render() {
        return (
            <div>
                <h1>{this.labels.title}</h1>
                <p dangerouslySetInnerHTML={{__html: this.props.config[`MES_NOUS_JOINDRE_${this.props.lngChild}`]}} />
            </div>
        );
    }
}

export default NousJoindreModal;